module.exports = __webpack_public_path__ + "img/option-card-center-modal-icon.e2b8e432.svg";